import * as React from 'react';
import { IOption } from '@cian/ui-kit/types';
import { InlineText2, Select } from '@cian/ui-kit';
import * as styles from './Dropdown.css';

interface IDropdownProps {
  label: string;
  options: IOption[];
  selected: number | string;
  onChange: (regionId: number) => void;
  dataTestId?: string;
}

export function Dropdown({ label, options, selected, onChange, dataTestId }: IDropdownProps) {
  return (
    <div className={styles['container']} data-testid={dataTestId}>
      <InlineText2>{label}</InlineText2>
      <div className={styles['select']}>
        <Select options={options} value={selected} onChange={onChange} />
      </div>
    </div>
  );
}
